import api from './api';
import axios from 'axios';

const lawpayService = {
  // Get configuration status (available to any authenticated user)
  getStatus: () => api.get('/payments/config/status'),

  // Get full configuration (requires manage_firm_payments permission)
  getConfig: () => api.get('/payments/config'),

  // Save new configuration (requires manage_firm_payments permission)
  configure: (configData) => api.post('/payments/config', configData),

  // Update existing configuration (requires manage_firm_payments permission)
  updateConfig: (configData) => api.put('/payments/config', configData),

  // Test connection (if endpoint exists)
  testConnection: () => api.post('/payments/config/test'),

  // === Payment Links ===

  // Create a payment link
  createPaymentLink: (data) => api.post('/payments/links', data),

  // List payment links
  getPaymentLinks: (params = {}) => api.get('/payments/links', { params }),

  // Cancel a payment link
  cancelPaymentLink: (linkId) => api.delete(`/payments/links/${linkId}`),

  // Get public payment link info (no auth required)
  getPublicPaymentLink: (token) => {
    const baseUrl = process.env.REACT_APP_API_URL || '/api';
    return axios.get(`${baseUrl}/payments/pay/${token}`);
  },

  // Process payment from public page (no auth required)
  processPublicPayment: (token, paymentData) => {
    const baseUrl = process.env.REACT_APP_API_URL || '/api';
    return axios.post(`${baseUrl}/payments/pay/${token}`, paymentData);
  },

  // Get surcharge info for a payment link (no auth required)
  getSurchargeInfo: (token, amountCents) => {
    const baseUrl = process.env.REACT_APP_API_URL || '/api';
    return axios.get(`${baseUrl}/payments/pay/${token}/surcharge`, {
      params: { amount: amountCents }
    });
  },

  // Legacy alias for backward compatibility
  createHostedPaymentPage: (data) => api.post('/payments/links', data),

  // === Payment Plans ===

  // Create a payment plan
  createPaymentPlan: (data) => api.post('/payments/plans', data),

  // List payment plans
  getPaymentPlans: (params = {}) => api.get('/payments/plans', { params }),

  // Get a specific payment plan
  getPaymentPlan: (planId) => api.get(`/payments/plans/${planId}`),

  // Activate a payment plan
  activatePaymentPlan: (planId, data) => api.post(`/payments/plans/${planId}/activate`, data),

  // Pause a payment plan
  pausePaymentPlan: (planId) => api.post(`/payments/plans/${planId}/pause`),

  // Resume a payment plan
  resumePaymentPlan: (planId) => api.post(`/payments/plans/${planId}/resume`),

  // Cancel a payment plan
  cancelPaymentPlan: (planId, reason) => api.post(`/payments/plans/${planId}/cancel`, null, { params: { reason } }),

  // === Direct Charges ===

  // Create a direct charge using a saved payment method
  createCharge: (data) => api.post('/payments/charge', data),

  // Get client's saved payment methods
  getClientPaymentMethods: (clientId) => api.get(`/payments/clients/${clientId}/payment-methods`),

  // === Transactions ===

  // Get transaction history
  getTransactions: (params = {}) => api.get('/payments/transactions', { params }),

  // Get a specific transaction
  getTransaction: (transactionId) => api.get(`/payments/transactions/${transactionId}`),
};

export default lawpayService;
